import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { filterReducer } from "../redux/features/filter/filterSlice";

export default function SideBar() {
  const [tab, setTab] = useState("All");
  const dispatch = useDispatch();
  const tabColor = "rgb(59 130 246 / var(--tw-text-opacity))";

  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <Link
              to="/"
              className={`main-menu ${tab === "All" && "menu-active"}`}
              id="lws-alljobs-menu"
              onClick={() => {
                setTab("All");
                dispatch(filterReducer(""));
              }}
            >
              <i className="fa-solid fa-briefcase"></i>
              <span> All Available Jobs</span>
            </Link>

            <ul className="space-y-6 lg:space-y-2">
              <li>
                <Link
                  to="/"
                  className="sub-menu"
                  style={{
                    color: tab === "Internship" && tabColor,
                  }}
                  id="lws-internship-menu"
                  onClick={() => {
                    setTab("Internship");
                    dispatch(filterReducer("Internship"));
                  }}
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]"></i>{" "}
                  Internship
                </Link>
              </li>

              <li>
                <Link
                  to="/"
                  className="sub-menu"
                  style={{
                    color: tab === "Full Time" && tabColor,
                  }}
                  id="lws-fulltime-menu"
                  onClick={() => {
                    setTab("Full Time");
                    dispatch(filterReducer("Full Time"));
                  }}
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]"></i> Full Time
                </Link>
              </li>

              <li>
                <Link
                  to="/"
                  className="sub-menu"
                  style={{
                    color: tab === "Remote" && tabColor,
                  }}
                  id="lws-remote-menu"
                  onClick={() => {
                    setTab("Remote");
                    dispatch(filterReducer("Remote"));
                  }}
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4]"></i> Remote
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link
              to="/create"
              className={`main-menu ${tab === "AddJob" && "menu-active"}`}
              id="lws-addJob-menu"
              onClick={() => {
                setTab("AddJob");
              }}
            >
              <i className="fa-solid fa-file-circle-plus"></i>
              <span> Add New Job</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}
